import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import formService from "../../services/forms/form.service";
import adminService from "../../services/admin/admin.services";
import { AnketRequestDto } from "../../services/forms/form.dto";
import { VideoDto } from "../../services/admin/admin.dto";
import { useToast } from "../../utils/toast";
import { InputTextarea } from "primereact/inputtextarea";
import ProtokolFirmalarComponent from "../../components/ProtokolFirmalarComponent";
import VideoComponent from "../../components/VideoComponent";
import LoginRequiredModal from "../../components/LoginRequiredModal";
import { useAuth } from "../../utils/auth";
import { useNavigate } from "react-router-dom";

const getYoutubeThumbnail = (url: string) => {
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})/);
  const id = match ? match[1] : "";
  return id ? `https://img.youtube.com/vi/${id}/mqdefault.jpg` : "/images/landing-page/hesaplama.jpg";
};

const OsbukBulten = () => {
  const toast = useToast();
  const auth = useAuth();
  const navigate = useNavigate();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [answer, setAnswer] = useState<string>("");
  const [videos, setVideos] = useState<VideoDto[]>([]);
  const [selectedVideo, setSelectedVideo] = useState<VideoDto | null>(null);

  useEffect(() => {
    loadVideos();
  }, []);

  const loadVideos = async () => {
    try {
      const response = await adminService.getVideos("BULTEN");
      if (response?.result?.data) {
        setVideos(response.result.data);
        if (response.result.data.length > 0) {
          setSelectedVideo(response.result.data[0]);
        }
      }
    } catch (error) {
      console.error("Error loading videos:", error);
      toast.show("Video verilerini yüklerken bir hata oluştu.", "error");
    }
  };

  const handleVideoSelect = (video: VideoDto) => {
    setSelectedVideo(video);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = async () => {
    if (!auth.getUser().access_token) {
      setShowLoginModal(true);
      return;
    }

    try {
      if (answer.trim() === "") {
        toast.show("Lütfen formu doldurunuz.", "error");
        return;
      }
      const dto: AnketRequestDto = {
        result1: answer
      };

      const res = await formService.haberAnket(dto);
      if (res?.result?.error === null) {
        toast.show("Form başarıyla kaydedildi!", "success");
        setAnswer("");
      } else {
        toast.show("Form gönderiminde hata oluştu.", "error");
      }
    } catch (error) {
      toast.show("Bir hata oluştu. Lütfen tekrar deneyin.", "error");
    }
  };

  return (
    <>
      {selectedVideo && (
        <VideoComponent videoUrl={selectedVideo.video_url} header={selectedVideo.title} autoplay={true} />
      )}

      <div className="card p-3 sm:p-4 mb-3">
        <div className="text-center mb-4">
          <h2 className="text-900 text-2xl sm:text-3xl font-semibold mb-2">OSBÜK Bülten Video Arşivi</h2>
        </div>
        <div className="grid">
          {videos.map((video) => (
            <div className="col-12 sm:col-6 lg:col-4" key={video.id}>
              <div
                className="cursor-pointer border-round-xl overflow-hidden surface-card border-1 transition-duration-200 hover:shadow-2"
                onClick={() => handleVideoSelect(video)}
                style={{
                  borderColor: selectedVideo?.id === video.id ? "var(--primary-color)" : "var(--surface-border)",
                  borderWidth: selectedVideo?.id === video.id ? "2px" : "1px",
                }}
              >
                <div className="relative" style={{ aspectRatio: "16 / 9" }}>
                  <img
                    src={getYoutubeThumbnail(video.video_url)}
                    alt={video.title}
                    className="w-full h-full"
                    style={{ objectFit: "cover" }}
                  />
                  <div className="absolute top-0 bottom-0 left-0 right-0 flex align-items-center justify-content-center bg-black-alpha-30">
                    <i className="pi pi-play-circle text-white text-4xl opacity-80 hover:opacity-100"></i>
                  </div>
                </div>
                <div className="p-3">
                  <h4 className="text-900 m-0 text-base font-semibold line-clamp-2">{video.title}</h4>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="card p-3 sm:p-4 mb-3">
        <div className="text-center mb-4">
          <h2 className="text-900 text-2xl sm:text-3xl font-semibold mb-2">OSBÜK Bülten Anketi</h2>
        </div>

        <p className="text-900 font-medium mb-3">Bültenimizde hangi konulara yer vermemizi istersiniz?</p>
        <div className="w-full mb-3">
          <InputTextarea
            value={answer}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
              if (!auth.getUser().access_token) {
                setShowLoginModal(true);
                return;
              }
              setAnswer(e.target.value);
            }}
            rows={4}
            className="w-full"
            placeholder="Görüş ve önerilerinizi buraya yazabilirsiniz..."
            style={{ minHeight: "100px" }}
          />
        </div>

        <div className="flex justify-content-end">
          <Button label="Kaydet" icon="pi pi-check" onClick={handleSubmit} className="px-4" />
        </div>
      </div>

      <ProtokolFirmalarComponent />
      
      {/* Login Required Modal */}
      <LoginRequiredModal 
        visible={showLoginModal} 
        onHide={() => setShowLoginModal(false)} 
      />
    </>
  );
};

export default OsbukBulten;
